// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + ({"538":"recorder","983":"profiler"}[chunkId] || chunkId) + ".js";
};